import React, { useState, useEffect } from "react";
import Select from "react-select";
import { customStyles } from "../components/CustomSelectStyles";
import {
    fetchLookupDataWithName,
    getAllDoctorData,
    getFacility,
    getSlotData,
    saveAppointmentData,
} from "../utils/api";
import Calendar from "../components/Calendar";
import { formattedDate } from "../utils/utilities";
import NewPatientForm from "../components/NewPatientForm";

function AppointmentForm() {
    const [selectedFacility, setSelectedFacility] = useState(null);
    const [selectedSpecialization, setSelectedSpecialization] = useState(null);
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [facilityList, setFacilityList] = useState([]);
    const [specializationList, setSpecializationList] = useState([]);
    const [doctorList, setDoctorList] = useState([]);
    const [slotData, setSlotData] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedAppointment, setSelectedAppointment] = useState({
        time: "",
        date: "",
        duration: "",
        identification: "",
        type: "",
    });

    const [formValues, setFormValues] = useState({
        name: "",
        age: "",
        mobile: "",
        gender: "",
        reason: "",
    });

    const selectValues = [
        {
            label: "Facility",
            option: facilityList,
            value: selectedFacility,
            onChange: setSelectedFacility,
        },
        {
            label: "Specialization",
            option: specializationList,
            value: selectedSpecialization,
            onChange: setSelectedSpecialization,
        },
        {
            label: "Doctor",
            option: doctorList,
            value: selectedDoctor,
            onChange: setSelectedDoctor,
        },
    ];

    const handleBookAppointment = async () => {
        console.log("Appointment booked");
        const saveBody = {
            tenant_id: "cf913442-417b-4ae4-9921-71814ada603f",
            facility_name: selectedFacility.label,
            facility_id: selectedFacility.value,
            appointment_date: formattedDate(selectedDate),
            appointment_time: selectedAppointment.time,
            appointment_slot_duration: selectedAppointment.duration,
            appointment_status: "Unconfirmed",
            provider_id: selectedDoctor.value,
            provider_name: selectedDoctor.label.slice(4),
            specialization: selectedSpecialization.label,
            reason_of_visit: formValues.reason,
            mode_of_appointment: "Online",
            appointment_type: selectedAppointment.type,
            visit_type: "First",
            appointment_identification: selectedAppointment.identification,
            existing_patient: [],
            new_patient: [
                {
                    patient_id: "0",
                    patient_name: formValues.name,
                    mobile: formValues.mobile,
                    duration: null,
                    patient_status: "Unconfirmed",
                    form_values: {},
                    visit_type: "First",
                },
            ],
        };
        try {
            const response = await saveAppointmentData(saveBody);
            if (response.statusCode === 200) {
                console.log(response.message);
            } else {
                console.log(response.message);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        const fetchFacility = async () => {
            const facility = await getFacility();
            setFacilityList(
                facility.map((item) => ({
                    value: item.facility_id,
                    label: item.facility_name,
                }))
            );
        };

        fetchFacility();
    }, []);

    useEffect(() => {
        const fetchSpecialization = async () => {
            const specialization = await fetchLookupDataWithName("Speciality");
            setSpecializationList(specialization);
        };

        fetchSpecialization();
    }, []);

    useEffect(() => {
        const fetchDoctor = async () => {
            const doctor = await getAllDoctorData(
                selectedFacility?.label ?? "All",
                selectedSpecialization?.label ?? "All"
            );
            setDoctorList(
                doctor?.map((item) => ({
                    value: item.employee_id,
                    label:
                        "Dr. " +
                        (item.first_name ?? "") +
                        " " +
                        (item.last_name ?? ""),
                    specialization: item.specialization,
                }))
            );
        };

        fetchDoctor();
    }, [selectedFacility, selectedSpecialization]);

    useEffect(() => {
        setSpecializationList(
            selectedDoctor?.specialization.map((item) => ({
                value: item,
                label: item,
            }))
        );
    }, [selectedDoctor]);

    useEffect(() => {
        const fetchDoctor = async () => {
            const doctor = await getSlotData(
                [selectedDoctor.value],
                [formattedDate(selectedDate)],
                selectedFacility,
                selectedSpecialization
            );
            setSlotData(doctor[0].data);
        };

        if (selectedDoctor && selectedFacility && selectedSpecialization) {
            fetchDoctor();
        }
    }, [
        selectedDoctor,
        selectedFacility,
        selectedSpecialization,
        selectedDate,
    ]);

    useEffect(() => {
        setSelectedAppointment({
            time: "",
            date: "",
            duration: "",
            identification: "",
            type: "",
        });
    }, [selectedDate]);

    return (
        <>
            <h4 className="text-center">Book Appointment</h4>
            <div className="d-flex w-100">
                <div className="ms-4">
                    {selectValues.map((select, index) => (
                        <div className="col">
                            <label className=" me-0">{select.label}</label>
                            <span
                                className="text-danger"
                                style={{ fontSize: "18px" }}
                            >
                                *
                            </span>
                            <Select
                                options={select.option}
                                value={select.value}
                                onChange={(selected) => {
                                    select.onChange(selected);
                                }}
                                styles={customStyles}
                            />
                        </div>
                    ))}

                    <div className="mt-4">
                        <Calendar
                            onDateChange={(date) =>
                                setSelectedDate(new Date(date))
                            }
                        />
                    </div>
                </div>
                <div className="ms-5 col-8">
                    {slotData.length > 0 && (
                        <div className="mt-3">
                            <div>
                                <h5>{formattedDate(selectedDate)}</h5>
                            </div>
                            <div className="d-flex gap-3 flex-wrap">
                                {slotData.map((slot, index) => (
                                    <div>
                                        {slot.status === "Available" && (
                                            <button
                                                key={index} 
                                                className="btn btn-success"
                                                onClick={() =>
                                                    setSelectedAppointment({
                                                        time: slot.time,
                                                        date: formattedDate(
                                                            selectedDate
                                                        ),
                                                        duration: slot.duration,
                                                        identification:
                                                            slot.appointment_identification,
                                                        type: slot.appointment_type,
                                                    })
                                                }
                                            >
                                                {slot.time}
                                            </button>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    {selectedAppointment.time && (
                        <div className="mt-4">
                            <div>
                                <h6>
                                    Selected Appointment:{" "}
                                    {selectedAppointment.date}{" "}
                                    {selectedAppointment.time}
                                </h6>
                            </div>
                            <h6>Patient Details</h6>
                            <div className="d-flex gap-5 justify-content-evenly">
                                <input
                                    type="text"
                                    className="form-control mt-2"
                                    placeholder="Name"
                                    value={formValues.name}
                                    onChange={(e) =>
                                        setFormValues({
                                            ...formValues,
                                            name: e.target.value,
                                        })
                                    }
                                />
                                <input
                                    type="text"
                                    className="form-control mt-2"
                                    placeholder="Age"
                                    value={formValues.age}
                                    onChange={(e) =>
                                        setFormValues({
                                            ...formValues,
                                            age: e.target.value,
                                        })
                                    }
                                />
                                <input
                                    type="tel"
                                    className="form-control mt-2"
                                    placeholder="Mobile Number"
                                    value={formValues.mobile}
                                    onChange={(e) =>
                                        setFormValues({
                                            ...formValues,
                                            mobile: e.target.value,
                                        })
                                    }
                                    pattern="[0-9]{10}"
                                />
                            </div>
                            <div className="d-flex gap-5">
                            <div className="d-flex align-items-center gap-4">
                                Gender
                                <div className="d-flex gap-2">
                                    <input
                                        type="radio"
                                        checked={formValues.gender === "male"}
                                        onChange={() =>
                                            setFormValues({
                                                ...formValues,
                                                gender: "male",
                                            })
                                        }
                                        name="gender"
                                    />
                                    Male
                                </div>
                                <div className="d-flex gap-2">
                                    <input
                                        type="radio"
                                        checked={formValues.gender === "female"}
                                        onChange={() =>
                                            setFormValues({
                                                ...formValues,
                                                gender: "female",
                                            })
                                        }
                                        name="gender"
                                    />
                                    Female
                                </div>
                            </div>
                            <div className="col">
                                <input
                                    type="text"
                                    className="form-control mt-2"
                                    placeholder="Reason of Visit"
                                    value={formValues.reason}
                                    onChange={(e) =>
                                        setFormValues({
                                            ...formValues,
                                            reason: e.target.value,
                                        })
                                    }
                                />
                            </div>
                            </div>
                            <div>
                                <button
                                    className="btn btn-dark mt-4"
                                    onClick={() => handleBookAppointment()}
                                >
                                    Book Appointment
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="">

                <NewPatientForm />
            </div>
        </>
    );
}

export default AppointmentForm;
